import { render, staticRenderFns } from "./NavBarCo2.vue?vue&type=template&id=242df310"
import script from "./NavBarCo2.vue?vue&type=script&lang=js"
export * from "./NavBarCo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports